import axios from './axios'
import { CreateLessonRequestDto, LessonRequestDto, UpdateLessonRequestDto } from './types'

export const getLessonRequests = () => {
  return axios.get<LessonRequestDto[]>('/lesson-requests')
}

export const getLessonRequest = (id: string) => {
  return axios.get<LessonRequestDto>(`/lesson-requests/${id}`)
}

export const createLessonRequest = (data: CreateLessonRequestDto) => {
  return axios.post<LessonRequestDto>('/lesson-requests', data)
}

export const updateLessonRequest = (id: string, data: UpdateLessonRequestDto) => {
  return axios.put<LessonRequestDto>(`/lesson-requests/${id}`, data)
}

export const deleteLessonRequest = (id: string) => {
  return axios.delete<void>(`/lesson-requests/${id}`)
}
